
export async function initializeCoreSettings() {
    try {
        window.SEARCH_LIMIT = window.SEARCH_LIMIT || 300;

        if (window.snowballFactory && !window.stem) {
            window.stem = {};
            window.stem['RU'] = window.snowballFactory.newStemmer('russian');
            window.stem['EN'] = window.snowballFactory.newStemmer('english');
        }

        if (window.langCheckReload && !window.LANG) {
            window.LANG = window.langCheckReload('') || window.LANG_BROWSER || 'EN';
        }

        if (!window.cachedRequest) {
            window.cachedRequest = { 'request': '  ', 'filterUpdate': true, 'mCondPrev': [] };
        }

        if (!window.searchMode) window.searchMode = 'fulltext';
        if (!window.QUERY) window.QUERY = '';

        try {
            if (window.$ && window.$.urlParam) {
                window.QUERY = window.$.urlParam('sq') || '';
            }
        } catch(_) {}
    } catch (error) { throw error; }
}

export function clearOldLocalStorageEntries() {
    try {
        const keysToRemove = ['old_date_from', 'old_date_to', 'deprecated_filters'];
        keysToRemove.forEach(key => { if (localStorage.getItem(key)) localStorage.removeItem(key); });
    } catch (_) {}
}


